import { createSelector } from '@reduxjs/toolkit'

import { ACCOUNTANT_PAUSED_STATUS_TYPE_UNAVAILABLE } from '../constants'

const getAccountantSlice = (state) => state.accountant

export const getAccountant = createSelector([getAccountantSlice], (accountant) => ({
    ...accountant,
    isPausedAndUnavailable:
        accountant?.currentPausedDetails?.pausedStatusType === ACCOUNTANT_PAUSED_STATUS_TYPE_UNAVAILABLE,
    pausedStatusScheduledStartDate: accountant?.currentPausedDetails?.startDateUTC,
    pausedStatusScheduledEndDate: accountant?.currentPausedDetails?.scheduledEndDate,
    shortName: `${accountant.firstName || ''} ${String(accountant.lastName || '').charAt(0)}`.trim(),
    fullName: `${accountant.firstName || ''} ${String(accountant.lastName || '')}`.trim(),
}))
